import { useState } from "react";
import { PaperPlaneTilt, EnvelopeOpen } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterBand() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in! Welcome to the Ebikes&Gear journal.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err) || "Subscription failed — try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-6 rounded-[2rem] border border-border bg-card p-8 sm:p-10 sm:justify-between" data-testid="newsletter-band">
      <div className="flex items-start gap-4">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-primary/10 text-primary"><EnvelopeOpen size={24} weight="bold" /></span>
        <div>
          <h3 className="text-xl sm:text-2xl font-black tracking-tight">Get expert e-bike intel first</h3>
          <p className="mt-1 text-sm text-muted-foreground">New reviews, buying guides and Sur-Ron news — straight to your inbox. No spam, ever.</p>
        </div>
      </div>
      <form onSubmit={subscribe} className="flex w-full max-w-md items-center gap-2 rounded-full border border-border bg-background p-1.5" data-testid="newsletter-band-form">
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="w-full bg-transparent px-4 py-2 text-sm outline-none placeholder:text-muted-foreground"
          data-testid="newsletter-band-input"
        />
        <button type="submit" disabled={busy} className="btn-primary !px-5 !py-2.5 text-sm shrink-0" data-testid="newsletter-band-submit">
          {busy ? "..." : <>Subscribe <PaperPlaneTilt size={16} /></>}
        </button>
      </form>
    </div>
  );
}
